<template>
    <div class="">
        <!-- <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4">Provident Fund Reporting<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Provident Fund Reporting</span></h4> -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">GF Reports<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / GF Reports</span>
        </h4>
        <div class="payroll-reporting-tab" id="nav-tabContent-intro">
            <b-tabs content-class="reports-tab-wrapper" nav-wrapper-class="mb-2 reports-tab-nav-wrapper d-none">

                <b-tab title="PF Reports">

                    <p style="font-size: 15px;" class="text-secondary pt-4">Get a clear picture of your GF. Use this information to better understand your workforce.</p>
                    <b-tabs content-class="mt-3 reports-tab pf-tabs" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                        <b-tab>
                            <template #title>
                                <div class="row no-margin ">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div
                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">Employee GF Profile</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <!-- <template #title>

                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>Employee PF Profile</h5>
                                    <p>This report shows total breakdown of any selected month's payroll including all pay and allowances and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template> -->
                            <div>
                                <gf-employee-profile-report :pageurl="this.$api_url"></gf-employee-profile-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="row no-margin report-in-one-line">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">Monthly GF Report of Active Employees</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <!-- <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon"/>
                                    <h5>Monthly PF Report of Active Employees</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div> -->

                            </template>
                            <div>
                                <gf-monthly-report :pageurl="this.$api_url"></gf-monthly-report>
                                <!--<yearly-payroll-report :pageurl="this.$api_url"></yearly-payroll-report> -->
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>

                                <div class="row no-margin report-in-one-line">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div
                                                    class=" col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">Monthly GF Leaver Statement</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <!-- <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon"/>
                                    <h5>Monthly PF Leaver Statement</h5>
                                    <p>This report shows the total salary breakdown of each selected period's payroll including all pay and allowances and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div> -->

                            </template>
                            <div>
                                <gf-monthly-leaver-report :leaver="1" :pageurl="this.$api_url"></gf-monthly-leaver-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="row no-margin report-in-one-line">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div
                                                    class=" col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">GF Eligible Employees</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div>
                                <gf-eligible-employees-report :pageurl="this.$api_url"></gf-eligible-employees-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="row no-margin report-in-one-line">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div
                                                    class=" col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">GF Final Settlement Payable Details</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div>
                                <gf-final-settlement-payable-details-report :pageurl="this.$api_url"></gf-final-settlement-payable-details-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="row no-margin report-in-one-line">
                                    <template>
                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                            <div class="row no-margin">
                                                <div
                                                    class=" col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                    <h5 class="report_view_text px-2">GF Payment</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div>
                                <gf-payment-report :pageurl="this.$api_url"></gf-payment-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>
                <b-tab title="Profit Distribution" class="pf-tab-row">
                    <h4 class="mb-2 border-bottom pb-2 mt-5">Profit Distribution</h4>
                    <p>Get a clear picture of your payroll taxes. Use this information to better understand your tax compliance.</p>
                    <b-tabs content-class="mt-3 pf-tabs" nav-wrapper-class="mb-3 reports-tab-nav">
                        <template v-if="pf_settings.pf_profit_distribute_type.opt_value=='equal'">
                            <b-tab>
                                <template #title>
                                    <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                        <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon"/>
                                        <h5>Profit Distribution Report</h5>
                                        <p>This report shows the total profit breakdown of each selected period per employee.</p>
                                        <b-button class="btn btn-primary">View</b-button>
                                    </div>

                                </template>
                                <div>
                                    <pf-profit-distribute-report   :pageurl="this.$api_url"></pf-profit-distribute-report>
                                </div>
                            </b-tab>
                        </template>

                        <template v-if="pf_settings.pf_profit_distribute_type.opt_value=='cumilitive'">
                            <b-tab>
                                <template #title>
                                    <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                        <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                        <h5>Profit Distribution Report</h5>
                                        <p>This report shows the total profit breakdown of each selected period per employee.</p>
                                        <b-button class="btn btn-primary">View</b-button>
                                    </div>

                                </template>
                                <div>
                                    <pf-profit-distribute-report-new  :pf_settings="this.pf_settings" :pageurl="this.$api_url"></pf-profit-distribute-report-new>
                                </div>
                            </b-tab>
                        </template>
                         <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                            <b-tab>
                                <template #title>
                                    <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                        <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                        <h5>Profit Payable</h5>
                                        <p>This report shows the total salary breakdown of each selected period's payroll including employee.</p>
                                        <b-button class="btn btn-primary">View</b-button>
                                    </div>

                                </template>
                                <div>
                                <pf-profit-payable-report  :pageurl="this.$api_url"></pf-profit-payable-report>
                                </div>
                            </b-tab>
                        </template>

                    </b-tabs>
                </b-tab>
                <b-tab title="PF Advance Reports" class="pf-tab-row">
                    <h4 class="mb-2 border-bottom pb-2 mt-5">PF Advance Reports</h4>
                    <p style="font-size: 15px;">Get a clear picture of your PF Advance. Use this information to better understand your workforce.</p>
                    <b-tabs content-class="mt-3 pf-tabs" nav-wrapper-class="mb-3 reports-tab-nav">

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Schedule for Indvidual sdfsd</h5>
                                    <p>This report shows total breakdown of any selected month's payroll including all pay and allowances and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-schedule-report :pageurl="this.$api_url"></pf-loan-schedule-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Balance</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-monthly-report :pageurl="this.$api_url"></pf-loan-monthly-report>
                            </div>
                        </b-tab>
                         <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Summery</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-fiscal-report :pageurl="this.$api_url" :pf_settings="this.pf_settings"  ></pf-loan-fiscal-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Awating for Disbursment</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>


                            </template>
                            <div>
                                <pf-loan-awating-disbursement-report :pageurl="this.$api_url"></pf-loan-awating-disbursement-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Disbursment Report</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>


                            </template>
                            <div>
                                <pf-loan-disbursement-report :pageurl="this.$api_url"></pf-loan-disbursement-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Deduction Exception Report</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-deduction-exception-report :pageurl="this.$api_url"></pf-loan-deduction-exception-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Advance Manual Payment Report</h5>
                                    <p>This report shows the aggregate breakdown of any selected period's PF Advance Balance per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-early-settlement-report :pageurl="this.$api_url"></pf-loan-early-settlement-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>
                <b-tab title="PF Settlement Reports" class="pf-tab-row">
                    <h4 class="mb-2 border-bottom pb-2 mt-5">PF Settlement Reports</h4>
                    <p style="font-size: 15px;">Get a clear picture of your PF Settlement. Use this information to better understand your workforce.</p>
                    <b-tabs content-class="mt-3 pf-tabs" nav-wrapper-class="mb-3 reports-tab-nav">

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon"/>
                                    <h5>Awating for Disbursment Report</h5>
                                    <p>This report shows total breakdown of any selected fiscal year's settlement including all distribution and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-settlement-awating-disbursment-report :pageurl="this.$api_url"></pf-settlement-awating-disbursment-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>Disbursed Settlement Report</h5>
                                    <p>This report shows total breakdown of any selected fiscal year's settlement including all distribution and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-settlement-disbursment-report :pageurl="this.$api_url"></pf-settlement-disbursment-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>PF Settlement Report</h5>
                                    <p>This report shows total breakdown of any selected fiscal year's settlement including all distribution and deductions per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-settlement-report :pf_settings="this.pf_settings" :pageurl="this.$api_url"></pf-settlement-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>

                <!-- Start: Rejwan: 19-06-2025 Reoprting -->
                <!-- <template v-if="$atl_company_package_title != 'Provident Fund Only'"> -->
                <b-tab title="Auditors" class="pf-tab-row">
                    <h4 class="mb-2 border-bottom pb-2 mt-5">Auditors</h4>
                    <p>Get a clear picture of your Auditor reports. Use this information to better understand your workforce.</p>
                    <b-tabs content-class="mt-3 pf-tabs" nav-wrapper-class="mb-3 reports-tab-nav">

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Active Members Age Wise Report</h5>
                                    <p>This report shows total breakdown of active members report age wise.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <active-members-age-wise-report></active-members-age-wise-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Active Members Service Period Report</h5>
                                    <p>This report shows total active employees service period.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <active-members-service-period-report></active-members-service-period-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Division Wise Report</h5>
                                    <p>This report shows total active employees according to division.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <active-members-division-wise-report></active-members-division-wise-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Advance Summary Report</h5>
                                    <p>This report shows PF Advance Summary.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-advance-summary-report></pf-advance-summary-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Advance Status Report</h5>
                                    <p>This report shows PF Advance Status.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-advance-status-report></pf-advance-status-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Reasons for Taking Advance Report</h5>
                                    <p>This report shows reasons for taking advance.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-advance-applied-age-wise-report></pf-advance-applied-age-wise-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Advance Movement Report</h5>
                                    <p>This report shows pf advance movement.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-advance-movement-report></pf-advance-movement-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Employee Bank Account And Nominee Details Report</h5>
                                    <p>This report shows employee bank account and nominee details.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <employee-bank-account-nominee-details-report></employee-bank-account-nominee-details-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Employee Details Report</h5>
                                    <p>This report shows employee details.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <employee-details-report></employee-details-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Monthly PF Settlement Report</h5>
                                    <p>This report shows monthly PF Settlement Details.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-monthly-settlement-report></pf-monthly-settlement-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Awaiting For Installment Deduction Report</h5>
                                    <p>This report shows installments deduction list that are being awaited.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <awaiting-installment-deduction-report></awaiting-installment-deduction-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Monhtly Loan Collection Report</h5>
                                    <p>This report shows monthly loan collection.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <montly-loan-collection-report></montly-loan-collection-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Final Settlement Tracker Report</h5>
                                    <p>This report shows final settlement.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <final-settlement-tracker-report></final-settlement-tracker-report>
                            </div>
                        </b-tab>


                        <!-- Start: Sifat: 19-06-2025 Reporting -->
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Yearly PF Leaver Statement Report</h5>
                                    <p>This report shows yearly pf leaver statement.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-yearly-leaver-report></pf-yearly-leaver-report>
                            </div>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Advance Deduction List Report</h5>
                                    <p>This report shows pf advance deduction list.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-loan-advance-deduction-list></pf-loan-advance-deduction-list>
                            </div>
                        </b-tab>
                        <!-- End: Sifat: 19-06-2025 Reporting -->

                        <!-- Start: Rejwan: 02-07-2025 Reporting -->
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Member Movement Report</h5>
                                    <p>This report shows pf memeber movement list.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-member-movement-report></pf-member-movement-report>
                            </div>
                        </b-tab>
                        <!-- End: Rejwan: 02-07-2025 Reporting -->

                        <!-- Start: Rejwan: 07-07-2025 Reporting -->
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>PF Master Report</h5>
                                    <p>This report shows pf informations.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-master-report></pf-master-report>
                            </div>
                        </b-tab>
                        <!-- End: Rejwan: 07-07-2025 Reporting -->

                        <!-- Start: Rejwan: 08-07-2025 Reporting -->
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>
                                    <h5>Advance Details Report as per Auditor</h5>
                                    <p>This report shows advance details as per auditor.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-advance-details-report-as-per-auditor :pageurl="this.$api_url" :pf_settings="this.pf_settings"></pf-advance-details-report-as-per-auditor>
                            </div>
                        </b-tab>
                        <!-- End: Rejwan: 07-07-2025 Reporting -->
                    </b-tabs>
                </b-tab>
                <!-- </template> -->
                <!-- End: Rejwan: 19-06-2025 -->

                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                <b-tab title="Others" class="pf-tab-row">
                    <h4 class="mb-2 border-bottom pb-2 mt-5">Others</h4>
                    <p>Get a clear picture of your payroll taxes. Use this information to better understand your tax compliance.</p>
                    <b-tabs content-class="mt-3 pf-tabs" nav-wrapper-class="mb-3 reports-tab-nav">

                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>Profit and Loss Statement</h5>
                                    <p>This report shows the total salary breakdown of each selected period per employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                                <pf-pl-report  :pageurl="this.$api_url"></pf-pl-report>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" />
                                    <h5>Balance Sheet</h5>
                                    <p>This report shows the total salary breakdown of each selected period's payroll including employee.</p>
                                    <b-button class="btn btn-primary">View</b-button>
                                </div>

                            </template>
                            <div>
                               <pf-bs-report  :pageurl="this.$api_url"></pf-bs-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>
                </template>

            </b-tabs>
        </div>
       </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag'],
        components: {

        },
        data(){

            return {

                pageUrl:this.$api_url,

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},
                pf_settings :{pf_year_end:{ opt_value: 0, status: 0 },pf_profit_distribute_type:{ opt_value: 'equal', status: 0 },},

                empty_result : 'Fetching data..',

                fiscal_year : '',

                payroll_reporting_data : [],

            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            openMe: function()
            {
                this.$bvModal.show('view-details');
            },
            getPFSettings: function()
            {

                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;


                })
                .catch(function (error) {
                console.log(error);
                });

            },

        },
        created: function(){
            this.fiscal_year = this.getCurrentFinancialYear();
            this.getPFSettings();
        },
        computed:
        {

        }
    }
</script>
<style>
/* .payroll-reporting-tab .nav-tabs .nav-item {
	width: 24.25% !important;
    margin-right: 1%;
    margin-bottom: 1%;
}
.payroll-reporting-tab .nav-tabs .nav-item .nav-link {
  padding: 0px;
  border-radius: 10px !important;
  height: 100%;
} */
.payroll-reporting-tab .nav-item .nav-link.active .ibox-content-inner,
.payroll-reporting-tab .nav-item .nav-link:hover .ibox-content-inner,
 .payroll-reporting-tab .active.ibox-content-inner,
 .payroll-reporting-tab .ibox-content-inner:hover {
  background: #EFFCFC;
  border-color: #072C28 !important;
}
/* .payroll-reporting-tab .nav-tabs .nav-item .ibox-content-inner {
  padding: 10px !important;
} */
/* .payroll-reporting-tab .nav-tabs .nav-item h5 {
  font-size: 1.025rem;
} */
/* .payroll-reporting-tab .nav-tabs .nav-item .btn-primary {
  padding: 5px 15px !important;
} */
.payroll-reporting-tab .nav-tabs .nav-item:nth-child(4n) {
  margin-right: 0;
}
/* .payroll-reporting-tab .nav-tabs .nav-item img {
  width: 45px;
} */
.leave-attendance-dashboard .nav.nav-tabs .nav-item .nav-link.active::after {
  display: none;
}
.nav-tabs .nav-link.active {
  border-width: 0px !important;
}
.nav-tabs .nav-link:last-child {
  border-right-width: 0px !important;
}

</style>
